import groq from 'groq';

import { PERSON, RICH_TEXT } from '../common';

export const DEPARTMENT = groq`
  _type,
  title,
  people[]->{
    ${PERSON}
  }
`;

export const TEAM = groq`
  _type,
  title,
  description[] {
    ${RICH_TEXT}
  },
  departments[]-> {
    ${DEPARTMENT}
  }
`;

export const TEAM_BLOCK = groq`
  _type == 'timeline_team' => {
    ${TEAM}
  }
`;
